<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="往届嘉宾列表" name="1">
      <YqjbAdd :updataID='updataID'></YqjbAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 往届嘉宾修改
 */
import YqjbAdd from '../../../../static/form/YqjbAdd.vue'
export default {
  components: {
    YqjbAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Kyzhgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/YqjbUpdate.vue